import { find, isEmpty } from 'lodash';
import { lookupNumberField } from './utils';
import { 
  COMPANY_SHARES_FIELD,
  TYPE_SOCIETE_FIELD,
  TYPE_SOCIETE_MAP
} from '../organigramme.settings';

// const DOSSIER_TYPES = ['op', 'ho', 'im', 'at'];

function generateEntityId(entity: OrganigrammeEntity) {
  return `${entity.dossier_id || '' }|${entity.record_id || ''}`;
}

function lookupDossierType(object: any) {
  let field = find(object.fields, (f:any) => f.name === TYPE_SOCIETE_FIELD);

  if(field) {
    let type:string = TYPE_SOCIETE_MAP[field.value] || 'at';

    if(!isEmpty(type)) {
      return type;
    }
  }
  
  // Pretend that if not specified type is op
  return 'op';
}

export type OrganigrammeEntityType = 'dossier' | 'record';

export class OrganigrammeEntity {
  id: string
  type: OrganigrammeEntityType
  dossier_type: string

  dossier_id: string
  record_id: string
  name: string
  total_shares: number

  static buildFromDossier(dossier: any) {
    let entity = new OrganigrammeEntity();
    
    entity.type = 'dossier';
    entity.dossier_id = dossier.id;
    entity.name = dossier.name;
    
    if(dossier.record && dossier.record.length > 0) {
      let record = dossier.record[0].record;
      entity.record_id = record.id;
      
      entity.total_shares = lookupNumberField(record, COMPANY_SHARES_FIELD);
      entity.dossier_type = lookupDossierType(record);
    }

    entity.id = generateEntityId(entity);

    return entity;
  }

  static buildFromRecord(record: any) {
    let entity = new OrganigrammeEntity();
    entity.type = 'record';
    entity.record_id = record.id;
    entity.name = record.name;

    if(record.dossier && record.dossier.length > 0) {
      let dossier = record.dossier[0].dossier;
      entity.dossier_id = dossier.id;
      entity.type = 'dossier';

      entity.total_shares = lookupNumberField(record, COMPANY_SHARES_FIELD);

      if(dossier.record && dossier.record.length > 0) {
        entity.dossier_type = lookupDossierType(dossier.record[0].record);
      }
    }

    entity.id = generateEntityId(entity);

    return entity;
  }
}
